import { createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "min-h-screen max-h-screen w-screen flex relative lg:static bg-surface-0"
};
const _hoisted_2 = {
  class: "min-h-screen max-h-screen flex-1 flex flex-col overflow-auto"
};
const _hoisted_3 = {
  class: "p-5 flex-auto overflow-auto w-full h-full content-container relative"
};
import SideMenu from "@/components/menu/SideMenu.vue";
import TopMenu from "@/components/menu/TopMenu.vue";
import { ConfirmDialog } from "primevue";
export default {
  __name: 'AppLayout',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SideMenu), _createElementVNode("div", _hoisted_2, [_createVNode(TopMenu), _createElementVNode("div", _hoisted_3, [_createVNode(_component_router_view), _createVNode(_unref(ConfirmDialog))]), _cache[0] || (_cache[0] = _createElementVNode("div", {
        id: "page-footer"
      }, null, -1))])]);
    };
  }
};